import { render, staticRenderFns } from "./promote_label_modal.vue?vue&type=template&id=4dd31b63"
import script from "./promote_label_modal.vue?vue&type=script&lang=js"
export * from "./promote_label_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports